import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import {
  fetchCategories,
  reporteGeneralDeTransacciones,
  fetchGraphData,
  companySelector,
  GET_USER_PORTALS,
  GET_NEWS,
} from '@/store/graphql/queries/dashboard';

export default {
  namespaced: true,
  state: {
    categories: [],
    generalTransation: {
      data: [],
      total: 0,
    },
    queryVariables: null,
    graphData: [],
    graphDataVolume: [],
    companySelector: [],
    userPortals: [],
    novedades: {},
  },
  actions: {
    async fetchCategories({ state, commit }, variables) {
      try {
        if (state.categories && state.categories.length > 0) return;
        const result = await apolloClient.query({ query: fetchCategories, variables });
        if (result && result.data) {
          commit('SET_CATEGORIES', result.data);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async fetchGraphInformation({ commit }, variables) {
      try {
        const searchQuery = {
          query: fetchGraphData,
          variables,
          fetchPolicy: 'network-only',
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          if (variables.transactionsReport) {
            commit('SET_GRAPH_DATA', result.data.totalReports);
          } else {
            commit('SET_GRAPH_DATA_VOLUME', result.data.totalReports);
          }
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async fetchGeneralTransations({ commit }, variables) {
      try {
        const searchQuery = {
          query: reporteGeneralDeTransacciones,
          variables,
          fetchPolicy: 'network-only',
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_GENERAL_TRANSACTION', result.data);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async fetchDataForExcel(state, variables) {
      try {
        const searchQuery = {
          query: reporteGeneralDeTransacciones,
          variables,
          fetchPolicy: 'network-only',
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          return result.data;
        }
        return null;
      } catch (err) {
        window.console.error(err);
        return null;
      }
    },
    async fetchCompanySelector({ commit }, variables) {
      try {
        const searchQuery = {
          query: companySelector,
          variables,
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_COMPANY_SELECTOR', result.data.uniqueCompanies);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async fetchUserPortals({ commit }) {
      try {
        const result = await apolloClient.query({ query: GET_USER_PORTALS });
        if (result && result.data) {
          commit('SET_USER_PORTALS', result.data.userPortals);
        }
      } catch (err) {
        window.console.error(`No tiene un internal code válido, por eso no muestra los portales ${err}`);
      }
    },
    async fetchNews({ commit }, variables) {
      try {
        const result = await apolloClient.query({ query: GET_NEWS, variables });
        if (result && result.data && result.data.dashboard_novedades && result.data.dashboard_novedades.length > 0) {
          commit('SET_NOVEDADES', result.data.dashboard_novedades[0]);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
  },
  mutations: {
    SET_CATEGORIES(state, data) {
      const categoriesGrouped = [
        {
          title: 'CATEGORIAS USADAS',
          data: data.usedCategories,
        },
        {
          title: 'TODAS LAS CATEGORIAS',
          data: data.dashboard_categories,
        },
      ];
      Vue.set(state, 'categories', categoriesGrouped);
    },
    SET_GRAPH_DATA(state, data) {
      Vue.set(state, 'graphData', data);
    },
    SET_GRAPH_DATA_VOLUME(state, data) {
      Vue.set(state, 'graphDataVolume', data);
    },
    SET_GENERAL_TRANSACTION(state, data) {
      const grlTrans = {
        data: data.generalTransactions,
        total: data.totalRows.aggregate.count,
      };
      Vue.set(state, 'generalTransation', grlTrans);
    },
    SET_QUERY_VARIABLES(state, data) {
      Vue.set(state, 'queryVariables', data);
    },
    SET_COMPANY_SELECTOR(state, data) {
      Vue.set(state, 'companySelector', data);
    },
    SET_USER_PORTALS(state, data) {
      Vue.set(state, 'userPortals', data);
    },
    SET_NOVEDADES(state, data) {
      Vue.set(state, 'novedades', data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/dashboard.js